/* unplugin-vue-components disabled */import { render } from "./endAnswer.vue?vue&type=template&id=388b652f&scoped=true&ts=true"
import script from "./endAnswer.vue?vue&type=script&lang=ts"
export * from "./endAnswer.vue?vue&type=script&lang=ts"

import "./endAnswer.vue?vue&type=style&index=0&id=388b652f&lang=scss&scoped=true"

import exportComponent from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-388b652f"]])

export default __exports__